import axios from 'axios';
import moment from 'moment';
import 'moment/locale/it';
import store from '@/store';

// la locale italiana si registra senza diventare quella globale: il resto del BO resta com'era
moment.locale('en');
export const mIt = date => moment(date).locale('it');

/**
 * Chiamate della sezione Utenti > Task (backend /api/v1/tasks). Ritorna `data` della risposta;
 * gli errori del backend arrivano come Error con il messaggio leggibile ({ message }).
 */
export async function tasksApi(method, url, data) {
	try {
		const res = await axios({
			method,
			url: `${store.getters['settings/getUrl']}tasks/${url}`,
			data,
			params: method === 'get' ? data : undefined,
			headers: { Authorization: `Bearer ${store.getters['profile/getToken']}` },
		});
		return res.data;
	} catch (e) {
		const body = e.response && e.response.data;
		let message = 'Operazione non riuscita';
		if (body && typeof body.message === 'string') message = body.message;
		else if (body && Array.isArray(body.error) && body.error.length) message = body.error[0].msg;
		const err = new Error(message);
		err.status = e.response && e.response.status;
		throw err;
	}
}

export const api = {
	get: (url, params) => tasksApi('get', url, params).then(r => r.data),
	post: (url, data) => tasksApi('post', url, data).then(r => r.data),
	put: (url, data) => tasksApi('put', url, data).then(r => r.data),
	patch: (url, data) => tasksApi('patch', url, data).then(r => r.data),
	delete: url => tasksApi('delete', url).then(r => r.data),
	// liste paginate: { data, pagination }
	list: data => tasksApi('post', 'issues/lists', { data }),
};

// id dell'utente collegato, letto dal JWT (profile/getId in alcuni flussi contiene il profilo)
export function currentUserId() {
	try {
		const token = store.getters['profile/getToken'] || '';
		const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
		return payload.id ? String(payload.id) : '';
	} catch (e) {
		return '';
	}
}

export function notify(color, text) {
	store.dispatch('settings/updateSnackbar', { color, text, snackbar: true, mode: 'multi-line', timeout: 5000 });
}
